var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95245 4.91035C9.29113 4.86027 9.64051 4.83341 10.0003 4.83341C14.2545 4.83341 17.0461 8.58745 17.9839 10.0724C18.0974 10.2522 18.1542 10.342 18.1859 10.4806C18.2098 10.5847 18.2098 10.749 18.1859 10.8531C18.1541 10.9917 18.097 11.0821 17.9827 11.2631C17.7328 11.6585 17.3518 12.2143 16.8471 12.8171M5.6036 6.26261C3.80187 7.48483 2.57871 9.1829 2.01759 10.0712C1.90357 10.2516 1.84656 10.3419 1.81478 10.4805C1.79091 10.5846 1.7909 10.7488 1.81476 10.8529C1.84652 10.9915 1.90328 11.0813 2.01678 11.2611C2.95462 12.746 5.74618 16.5001 10.0003 16.5001C11.7157 16.5001 13.1932 15.8897 14.4073 15.0639M2.50035 3.16675L17.5003 18.1667M8.23258 8.89898C7.78017 9.35139 7.50035 9.97639 7.50035 10.6667C7.50035 12.0475 8.61963 13.1667 10.0003 13.1667C10.6907 13.1667 11.3157 12.8869 11.7681 12.4345",
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.43205e8611aab589a63adb97bb637f07.svg";
export { ForwardRef as ReactComponent };